import axios from "axios";
import { getProfileFirebase } from "./firebase";
import userMixin from "../mixins/userMixins";

const axiosWithoutInterceptor = axios.create();
function post(url, data) {
    let { csrf } = window;
    if (csrf === "" || typeof csrf !== "string") {
        csrf = document.getElementById("csrf")?.value;
    }
    return axiosWithoutInterceptor.post(
        url,
        {
            userId: window.currentUserId,
            csrf,
            ...data,
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
        },
    );
}

async function refreshToken() {
    try {
        const { token } = await getProfileFirebase();
        if (token) {
            const authToken = await userMixin.methods.getUserAuthToken();
            if (token !== authToken) {
                userMixin.methods.setNewToken(token);
            }
            return token;
        }
        throw new Error("User not logged in");
    } catch (error) {
        throw new Error(`Failed to refresh token: ${error.message}`);
    }
}

// Axios interceptor to attach the authentication token to requests
axios.interceptors.request.use(
    async (config) => {
        const authToken = await userMixin.methods.getUserAuthToken();
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// Function to handle API requests
async function fetchData(url) {
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            // Token expired, refresh it
            const newToken = await refreshToken();
            // Retry the request with the new token
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${newToken}`,
                },
            });
            return response.data;
        }
        throw error;
    }
}

async function postData(url, data) {
    try {
        const response = await axios.post(url, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            // Token expired, refresh it
            const newToken = await refreshToken();
            // Retry the request with the new token
            const response = await axios.post(url, data, {
                headers: {
                    Authorization: `Bearer ${newToken}`,
                },
            });
            return response.data;
        }
        throw error;
    }
}

async function putData(url, data) {
    try {
        const response = await axios.put(url, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            // Token expired, refresh it
            const newToken = await refreshToken();
            // Retry the request with the new token
            const response = await axios.put(url, data, {
                headers: {
                    Authorization: `Bearer ${newToken}`,
                },
            });
            return response.data;
        }
        throw error;
    }
}

async function patchData(url, data) {
    try {
        const response = await axios.patch(url, data);
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            // Token expired, refresh it
            const newToken = await refreshToken();
            // Retry the request with the new token
            const response = await axios.patch(url, data, {
                headers: {
                    Authorization: `Bearer ${newToken}`,
                },
            });
            return response.data;
        }
        throw error;
    }
}

export {
    // eslint-disable-next-line import/prefer-default-export
    post,
    fetchData,
    postData,
    putData,
    patchData,
};
